// extracted by mini-css-extract-plugin
module.exports =  {"container":"izCdy1v","figure":"Z_cGWKO","caption":"IgKy4Lf"};